import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { getApi } from "../../services/api/globalApi";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router"; 
import { giftListColumns } from "../../constant/tablesColumns/tablesColums";
export default function CampainOrderGiftDiscountList() {
  const [giftData, setGiftData] = useState([]);
  const [pagination, setPagination] = useState(null); 
  const getGiftData = async (params) => {
    const path = "admin/orderGifts";
    try {
      const response = await getApi({ path, params: { ...params } });
      setGiftData(response?.data?.result.data);
      setPagination(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getGiftData({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getGiftData(allFilter);
  };

  const data = [];

  giftData?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      id: item._id,
      faStatus:
        (item.status === "active"
          ? "فعال"
          : item.status === "pending"
            ? "انتظار"
            : "غیرفعال") || "pending",
      status: item.status,
    })
  );

  const navigate = useNavigate();

  const editLearn = (singleLearn) => {
    navigate("/gift-order-product-form", { state: singleLearn });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست هدیه ها"} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
      <Table columns={giftListColumns} rows={data} onEdit={editLearn} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
